export interface IMultiDropdownItem {
  name: string
  value: string
  description: string
}

export enum MULTI_DROPDOWN_KEYS {
  SHOP_HOME_FEATURED = 'SHOP_HOME_FEATURED',
}
